import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import SuccessModalOrder from "./ModalSuccessOrder";

const FormUpdateOrderPetani = () => {
  const { user } = useSelector((state) => state.auth);
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    beratSingkong: "",
    beratBatang: "",
    beratDaun: "",
    beratLimbahBatang: "",
    catatanLimbahBatang: "",
    beratLimbahDaun: "",
    catatanLimbahDaun: "",
    beratLimbahAkar: "",
    catatanLimbahAkar: "",
  });
  const [msg, setMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!id) {
      setMsg("Invalid order ID.");
      return;
    }

    if (!token) {
      setMsg("No token found, please login again.");
      return;
    }

    const fetchData = async () => {
      try {
        console.log("Fetching data for ID:", id);
        const response = await axios.get(
          `https://c-greenproject.org:8000/orderberlangsung/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.data) {
          setMsg("Order data not found.");
          return;
        }

        const data = response.data;
        setFormData({
          beratSingkong: data.beratSingkong || "",
          beratBatang: data.beratBatang || "",
          beratDaun: data.beratDaun || "",
          beratLimbahBatang: data.beratLimbahBatang || "",
          catatanLimbahBatang: data.catatanLimbahBatang || "",
          beratLimbahDaun: data.beratLimbahDaun || "",
          catatanLimbahDaun: data.catatanLimbahDaun || "",
          beratLimbahAkar: data.beratLimbahAkar || "",
          catatanLimbahAkar: data.catatanLimbahAkar || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response) {
          setMsg(
            error.response.status === 404
              ? "Order tidak ditemukan. Pastikan ID order benar."
              : `Error: ${
                  error.response.data.message || error.response.statusText
                }`
          );
        } else {
          setMsg("Terjadi kesalahan dalam mengambil data.");
        }
      }
    };

    fetchData();
  }, [id, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setMsg("No token found, please login again.");
      return;
    }
    try {
      await axios.patch(
        `https://c-greenproject.org:8000/inputtransaksi/${id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setShowModal(true);
    } catch (error) {
      console.error("Error updating data:", error);
      setMsg(
        error.response
          ? `Error: ${error.response.data.message || error.response.statusText}`
          : "Terjadi kesalahan saat memperbarui data."
      );
    }
  };

  return (
    <>
      <Container>
        <nav aria-label="breadcrumb pb-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/order">Order Aktif</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Update Order
            </li>
          </ol>
        </nav>
        <h2 className="my-4">
          <strong>Update Data Limbah Petani</strong>
        </h2>
        <Card className="p-4">
          <Form onSubmit={handleSubmit}>
            {msg && <p className="text-center text-danger">{msg}</p>}
            {user?.role === "petani" && (
              <Row>
                {["Batang", "Daun", "Akar"].map((type) => (
                  <Col md={4} key={type}>
                    <Form.Group className="mb-3">
                      <Form.Label>Berat Limbah {type} (kg)</Form.Label>
                      <Form.Control
                        type="text"
                        name={`beratLimbah${type}`}
                        value={formData[`beratLimbah${type}`]}
                        onChange={handleChange}
                        placeholder={`Berat Limbah ${type}`}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Catatan Limbah {type}</Form.Label>
                      <Form.Control
                        as="textarea"
                        name={`catatanLimbah${type}`}
                        value={formData[`catatanLimbah${type}`]}
                        onChange={handleChange}
                        placeholder={`Catatan Limbah ${type}`}
                        rows={5}
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            )}
            <Button variant="success" type="submit">
              Update
            </Button>
          </Form>
        </Card>
      </Container>
      <SuccessModalOrder
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Data limbah telah dicatat."
      />
    </>
  );
};

export default FormUpdateOrderPetani;
